import loadable from '@loadable/component';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useTenantControlGetHook';

const OverViewComponent = loadable(
  () => import('../../components/Dashboard/Dashboard')
);
const Overview = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ['sms-count'],
    url: APIS.SMS,
    params: {},
  });

  return (
    <>
      <OverViewComponent data={data} isLoading={isLoading} />
    </>
  );
};

export default Overview;
